import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { Text } from 'components/typography';
import classNames from 'classnames';
import { formatResourceName } from 'utils/formatResourceName';
import { LaundryBrikkModalContext } from '../../../../../LaundryBrikkModalContext';
import styles from './styles.module.scss';

export const ResourceSelectionSection = ({ laundryResources }) => {
  const intl = useIntl();
  const { selectedResource, setSelectedResource } = useContext(
    LaundryBrikkModalContext,
  );

  return (
    <div className={styles.resourceSelection}>
      {laundryResources.map((resource) => (
        <div
          key={resource.id}
          className={classNames(
            styles.resourceCard,
            selectedResource?.id === resource.id && styles.active,
          )}
          onClick={() => {
            if (selectedResource?.id === resource.id) setSelectedResource();
            else setSelectedResource(resource);
          }}
        >
          <div
            className={classNames(
              styles.icon,
              selectedResource?.id === resource.id && styles.activeIcon,
            )}
          >
            {resource?.icon}
          </div>
          <Text
            size={14}
            center
            className={
              selectedResource?.id === resource.id && styles.activeText
            }
          >
            {formatResourceName(resource?.name, intl.locale)}
          </Text>
        </div>
      ))}
    </div>
  );
};
